module.exports = __webpack_public_path__ + "static/media/33879.b2536072.jpg";